import { ActionTypes } from "../contants/action-types";
import supabase from "../../supabase";

export const fetchJobs = (params) => async (dispatch) => {
    if(params){
        let { data: Jobs, error } = await supabase
            .from('Jobs')
            .select('*')
            .order('id', {ascending: false})
            .range(params.start,params.end)
        let { data: jobscount, error2 } = await supabase
            .from('Jobs')
            .select('*')
            .order('id', {ascending: false});
        if(Jobs && jobscount){
            dispatch({ type: ActionTypes.FETCH_JOBS, payload: Jobs });
            return {data:Jobs,success:true,count:jobscount.length}
        }else if(error){
            return {error:error,success:false}
        }
    }
    let { data: Jobs, error } = await supabase
        .from('Jobs')
        .select('*')
        .order('id', {ascending: false});
    if(Jobs){
        dispatch({ type: ActionTypes.FETCH_JOBS, payload: Jobs });
        return {data:Jobs,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};

export const filterJobs = (param) => async (dispatch) => {
    if(param.end){
        let { data: Jobs, error } = await supabase
            .from('Jobs')
            .select("*")
            .ilike('position', `%${param.position}%`)
            .order('id', {ascending: false})
            .range(param.start,param.end)
        let { data: jobscount, error2 } = await supabase
            .from('Jobs')
            .select("*")
            .ilike('position', `%${param.position}%`)
            .order('id', {ascending:false})
        if(Jobs){
            dispatch({ type: ActionTypes.FETCH_JOBS, payload: Jobs });
            return{data:Jobs,success:true,count:jobscount.length}
        }else if(error){
            return{error:error,success:false}
        }
    }
    let { data: Jobs, error } = await supabase
    .from('Jobs')
    .select("*")
    .ilike('position', `%${param.position}%`)
    .order('id', {ascending: false})
    if(Jobs){
        dispatch({ type: ActionTypes.FETCH_JOBS, payload: Jobs });
        return{data:Jobs,success:true}
    }else if(error){
        return{error:error,success:false}
    }
}

export const addJob = (jobdata) => async (dispatch) => {
    const { data, error } = await supabase
    .from('Jobs')
    .insert([
    { position: jobdata.position, type: jobdata.type,location:jobdata.location,experience:jobdata.experience,tags:jobdata.tags,status:jobdata.status,description:jobdata.description },
    ])
    .select()
    if(data){
        return {data:data,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};

export const fetchJob = (id) => async (dispatch) => {
    let { data: Jobs, error } = await supabase
    .from('Jobs')
    .select("*")
    .eq('id', id)
    if(Jobs){
        dispatch({ type: ActionTypes.SET_JOB, payload: Jobs[0] });
        return{data:Jobs,success:true}
    }else if(error){
        return{error:error,success:false}
    }
};

export const deleteJob = (id) => async (dispatch) => {
    const { error } = await supabase
    .from('Jobs')
    .delete()
    .eq('id', id)
    if(!error){
        return {success:true}
    }else if(error){
        return {success:false}
    }
};

export const updateJob = (jobdata) => async (dispatch) => {
    const { data, error } = await supabase
    .from('Jobs')
    .update({ position: jobdata.position, type: jobdata.type,location:jobdata.location,experience:jobdata.experience,tags:jobdata.tags,status:jobdata.status,description:jobdata.description })
    .eq('id', jobdata.id)
    .select()
    if(data){
        return {data:data,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};  

export const updateStatus = (jobdata) => async (dispatch) => {
    const { data, error } = await supabase
    .from('Jobs')
    .update({ status:jobdata.status })
    .eq('id', jobdata.id)
    .select()
    if(data){
        return {data:data,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};  

export const getJobByType = (type,id) => async (dispatch) => {
    let { data: Jobs, error } = await supabase
        .from('Jobs')
        .select("*")
        .eq('type', type)
    const filterJobs = Jobs.filter((item)=>{
        if(item.id !== id){
            return item
        }
    })
    let finalarray
    if(filterJobs.length>2){
        finalarray = filterJobs.slice(0,2)
    }else{
        finalarray = filterJobs
    }
    if(Jobs){
        dispatch({ type: ActionTypes.GET_JOBS_BY_TYPE, payload: finalarray });
        return {data:Jobs,success:true}
    }else if(error){
        return {error:error,success:false}
    }
};
